export default function trackImageWidth(
	img,
	varName = '--img-width',
	max = 12
) {
	const MIN = 4;
	const MAX = max || 12;

	const update = () => {
		const width = img.clientWidth;
		const radius = Math.min( MAX, Math.max( MIN, width * 0.05 ) );
		img.parentElement?.style.setProperty( varName, `${ radius }px` );
	};

	if ( img.complete ) {
		update();
	} else {
		img.addEventListener( 'load', update, { once: true } );
	}

	const ro = new ResizeObserver( update );
	ro.observe( img );

	return () => ro.disconnect();
}
